import React, { useState, useEffect } from "react";
import axios from "axios";

export default function ReportsTable({ props }) {
  const [filters, setFilters] = useState({
    period: "",
    form: "",
    division: "",
  });

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const periods = props.periods;
  const forms = props.forms;
  const divisions = props.divisions;
  const [summary, setSummary] = useState({ total: 0, submitted_count: 0 });
  const [showOnlySubmitted, setShowOnlySubmitted] = useState(false);
  const [showOnlyNotSubmitted, setShowOnlyNotSubmitted] = useState(false);

  const fetchData = async () => {
    const response = await axios.get("/settings/all_reports", {
      params: filters,
    });
    setData(response.data.users);
    setSummary({
      total: response.data.total,
      submitted_count: response.data.submitted_count,
    });
  };

  useEffect(() => {
    let filtered = data;

    // Фильтрация: показывать только сдавших
    if (showOnlySubmitted) {
      filtered = data.filter((user) => user.submitted);
    }

    // Фильтрация: показывать только несдавших
    if (showOnlyNotSubmitted) {
      filtered = data.filter((user) => !user.submitted);
    }

    setFilteredData(filtered);
  }, [data, showOnlySubmitted, showOnlyNotSubmitted]);

  return (
    <div className="p-4">
      {/* Фильтры */}
      <div className="flex gap-4 mb-4">
        <select
          onChange={(e) => setFilters({ ...filters, period: e.target.value })}
        >
          <option value="">Выберите период</option>
          {periods.map((period) => (
            <option key={period.id} value={period.id}>
              {period.period}
            </option>
          ))}
        </select>

        <select
          onChange={(e) => setFilters({ ...filters, form: e.target.value })}
        >
          <option value="">Выберите форму</option>
          {forms.map((form) => (
            <option key={form.id} value={form.id}>
              {form.short_name}
            </option>
          ))}
        </select>

        <select
          onChange={(e) => setFilters({ ...filters, division: e.target.value })}
        >
          <option value="">Выберите отдел</option>
          {divisions.map((division) => (
            <option key={division.id} value={division.id}>
              {division.name.trim()}
            </option>
          ))}
        </select>

        <button
          onClick={fetchData}
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          Показать
        </button>
      </div>

      {/* Переключатели */}
      <div className="flex items-center gap-4 mb-4">
        <label className="flex items-center">
          <input
            type="checkbox"
            checked={showOnlySubmitted}
            onChange={(e) => {
              setShowOnlySubmitted(e.target.checked);
              setShowOnlyNotSubmitted(false);
            }}
            className="w-4 h-4 mr-2"
          />
          Показывать только сдавших
        </label>

        <label className="flex items-center">
          <input
            type="checkbox"
            checked={showOnlyNotSubmitted}
            onChange={(e) => {
              setShowOnlyNotSubmitted(e.target.checked);
              setShowOnlySubmitted(false);
            }}
            className="w-4 h-4 mr-2"
          />
          Показывать только несдавших
        </label>
      </div>

      {/* Сводка */}
      <h3>
        Количество сдавших: {summary.submitted_count} из {summary.total}
      </h3>

      {/* Таблица */}
      <table className="w-full border-collapse border">
        <thead>
          <tr className="bg-gray-200">
            <th className="border p-2">№ п/п</th>
            <th className="border p-2">Пользователь</th>
            <th className="border p-2">Наименование отчета</th>
            <th className="border p-2">Дата изменения</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((user, index) => (
            <tr
              key={user.id}
              className={user.submitted ? "bg-white" : "bg-gray-100"}
            >
              <td className="border p-2 text-center">{index + 1}</td>
              <td className="border p-2">{user.name}</td>
              <td className="border p-2">
                {user.report_id ? (
                  <a
                    href={`/reports/${user.report_id}/edit`}
                    className="text-blue-500 underline"
                  >
                    {user.report_name}
                  </a>
                ) : (
                  <span>{user.report_name}</span>
                )}
              </td>
              <td className="border p-2">{user.date_created}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
